import { render, staticRenderFns } from "./Comfirm.vue?vue&type=template&id=0d4a9982"
import script from "./Comfirm.vue?vue&type=script&lang=js"
export * from "./Comfirm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports